// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/icons/chevron-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/icons/home_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/icons/account_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/icons/account_icon_sel.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/icons/profile_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/icons/profile_icon_sel.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/icons/bell_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/icons/bell_icon_sel.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/icons/account_icon_black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/icons/profile_icon_black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/icons/bell_icon_black.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;1,400;1,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --branded-purple: rgb(135, 60, 170);
  --branded-purple-border: #beaad6;
  --branded-light-purple: #e7e0f1;
  --branded-extra-light-purple: #f9f3ff;
  --branded-action-purple: #8c28e4;
  --branded-blue: #00508e;
  --branded-darker-gray: #333333;
  --branded-dark-gray: #22272a;
  --branded-light-gray: #ccced0;
  --branded-font-color: #383838;
  --branded-text-color: #495057;
  --branded-gray: #f2f2f2;
  --branded-error-red: #b30000;
  --branded-yellow: #f2c94c;
  --branded-validation-green: #00b298;

  --branded-traffic-red: #b81d13;
  --branded-traffic-red-bg: #f9cac7;
  --branded-traffic-yellow: #8f6e00;
  --branded-traffic-yellow-bg: #ffe693;
  --branded-traffic-green: #008450;
  --branded-traffic-green-bg: #b3ffe1;
}

html,
body {
  padding: 0;
  margin: 0;
  font-family: "Lato", sans-serif;
  background-color: var(--branded-gray);
}

header > .wrapper > a {
  min-width: 130px;
}

.custom-theme {
  display: grid;
  height: 100vh;
  grid-template-columns: auto;
  grid-template-rows: 80px auto;
  grid-template-areas:
    "header"
    "body-main";
  transition: grid 300ms ease;
}

.page-with-sidebar {
  display: grid;
  grid-template-columns: 250px auto;
  grid-template-areas: "sidebar main-content";
}

.main-content {
  border-radius: 0;
  box-shadow: none !important;
  margin-right: 0 !important;
  height: calc(100vh - 100px);
  padding-top: 0px !important;
  padding-bottom: 50px !important;
  padding-left: 5rem;
  padding-right: 5rem;
}

a {
  color: inherit;
  text-decoration: none;
}

* {
  box-sizing: border-box;
}

.container {
  width: 1200px;
  margin: 0 auto;
}

.blue-gradient {
  background: rgb(20, 93, 154);
  background: linear-gradient(
    90deg,
    rgba(20, 93, 154, 1) 0%,
    rgba(0, 125, 211, 1) 100%
  );
}

.green-gradient {
  background: rgb(0, 178, 152);
  background: linear-gradient(
    90deg,
    rgba(0, 178, 152, 1) 0%,
    rgba(38, 66, 101, 1) 100%
  );
}

.btn {
  display: inline-flex;
  cursor: pointer;
  color: white;
  font-size: 1rem;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: var(--branded-purple);
}

.btn-sm {
  display: inline-flex;
  cursor: pointer;
  color: white;
  font-size: 0.875rem;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  background-color: var(--branded-purple);
}

button:disabled,
button[disabled] {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}

button:disabled:hover,
button[disabled]:hover {
  color: white !important;
}

.custom-tooltip .p-tooltip-text {
  font-size: 13px;
  border: 1px solid var(--branded-light-purple) !important;
  background-color: white !important;
  color: #383838 !important;
}

.custom-tooltip .p-tooltip-arrow {
  background-color: transparent !important;
  border: none !important;
}

body > iframe {
  display: none;
}

.profile-menu img:hover {
  border: none !important;
}

.custom_dialog {
  padding: 25px !important;
  background-color: white !important;
}

.custom_dialog .p-dialog-header {
  border-bottom: 3px solid var(--branded-light-purple) !important;
  padding: 0px 0px 15px 0px !important;
}

.custom_dialog .p-dialog-header-icon {
  color: var(--branded-purple) !important;
  background-color: rgba(222, 190, 237, 0.5) !important;
}

.custom_dialog .p-dialog-content {
  padding: 15px 0px 0px 0px !important;
}

.custom_dialog .p-dialog-footer {
  border-top: 0 !important;
  padding: 15px 0px 0px 0px !important;
}

.header-menu {
  border: solid 1px gray;
  border-radius: 8px;

  .p-menu .p-menuitem .p-menuitem-text {
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--branded-font-color) !important;
  }

  .p-menuitem-link {
    font-size: 0.9rem;

    .p-menuitem-text {
      font-weight: 600;
    }
  }

  .p-menu .p-menuitem .p-menuitem-icon {
    font-size: 1rem;
    font-weight: 500;
  }

  .p-panelmenu .p-panelmenu-header-link {
    background-color: transparent;
    color: #eff3f8;
  }

  .p-panelmenu .p-panelmenu-header-link:hover {
    background-color: #22272a38;
  }

  .p-panelmenu .p-menuitem-link {
    color: #ddd;
  }

  .p-panelmenu .p-menuitem-link:hover {
    color: #fff;
  }
}

.field-radiobutton label {
  color: var(--branded-font-color);
}

.custom-breadcrumb {
  background-color: transparent !important;
  padding-top: 1.5rem;

  ul {
    background-color: transparent !important;
    display: flex !important;
    list-style: none !important;
    flex-direction: row !important;
    padding: 0;
    margin: 0;

    li:first-child {
      display: none;
    }
  }

  .p-breadcrumb-chevron::before {
    display: inline-block;
    color: transparent;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
    width: 20px;
    height: 20px;
  }

  .p-menuitem-text {
    font-size: 1rem;
    color: var(--branded-font-color) !important;
  }

  .pi .pi-home::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    width: 20px;
    height: 20px;
  }
}

.sidebar-menu {
  margin-top: 15vh;
  width: 100% !important;
  border: none !important;
  background-color: transparent !important;

  .p-menuitem-text,
  .p-menuitem-icon {
    color: #eff3f8 !important;
  }

  .p-menuitem-text {
    font-size: 1.1rem !important;
  }

  .p-menuitem-link {
    height: 56px;
  }

  .p-menuitem-link:not(.p-disabled):hover {
    background: transparent !important;
  }

  .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover {
    font-weight: 500 !important;
    color: #eff3f8 !important;
    background: #383c3f !important;
  }

  .p-focus .p-menuitem-link {
    background-color: #383c3f !important;
  }
}

.account-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center;
  background-size: contain;
  display: inline-block;
  width: 24px;
  height: 24px;

  /* &:hover {
    background: url('../assets/icons/account_icon_sel.svg') no-repeat center;
  } */

  &.selected {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center;
  }
}

.profile-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center;
  background-size: contain;
  display: inline-block;
  width: 24px;
  height: 24px;

  /* &:hover {
    background: url('../assets/icons/profile_icon_sel.svg') no-repeat center;
  } */

  &.selected {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center;
  }
}

.bell-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center;
  background-size: contain;
  display: inline-block;
  width: 24px;
  height: 24px;

  /* &:hover {
    background: url('../assets/icons/bell_icon_sel.svg') no-repeat center;
  } */

  &.selected {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center;
  }
}

.account-icon-mobile {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat center;
  background-size: contain;
  display: inline-block;
  width: 24px;
  height: 24px;

  /* &:hover {
    background: url('../assets/icons/account_icon_sel.svg') no-repeat center;
  } */

  &.selected {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center;
  }
}

.profile-icon-mobile {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center;
  background-size: contain;
  display: inline-block;
  width: 24px;
  height: 24px;

  /* &:hover {
    background: url('../assets/icons/profile_icon_sel.svg') no-repeat center;
  } */

  &.selected {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center;
  }
}

.bell-icon-mobile {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center;
  background-size: contain;
  display: inline-block;
  width: 24px;
  height: 24px;

  /* &:hover {
    background: url('../assets/icons/bell_icon_sel.svg') no-repeat center;
  } */

  &.selected {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center;
  }
}

label {
  color: #495057 !important;
}

.line {
  background-color: #e7e0f1;
  height: 3px;
  margin-top: 0px;
  margin-bottom: 0px;
  border: none;
}

.pageHeader {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.pageHeaderCustom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 20px;
  padding-top: 0px;
  margin-top: -3px;
}

.p-calendar {
  .p-button-icon-only {
    height: 40px;
  }

  .p-inputtext {
    border: none !important;
  }
}

.p-multiselect .p-multiselect-label .p-placeholder {
  font-size: 0.89rem !important;
  color: #999999;
}

/* Mobile */
@media (max-width: 767px) {
  .page-with-sidebar {
    grid-template-columns: auto;
    grid-template-areas: "main-content";
  }

  .sidebar {
    display: none;
  }
}

@media (max-width: 460px) {
  /* header > .wrapper {
    align-items: start;
    gap: 1rem;
    padding-left: 0;
    padding-right: 0;
    flex-wrap: wrap;
  } */

  .custom-breadcrumb {
    padding-top: 1rem;
    padding-bottom: 0.5rem;
  }

  .main-content {
    height: calc(100vh - 100px);
  }

  /* .custom-theme {
    grid-template-rows: 130px auto !important;
  } */

  /* header .nav-top {
    justify-content: start;
  } */

  /* .body-main {
    height: calc(100vh - 80px) !important;
  } */
}

.rlink-card {
  background-color: rgba(231, 224, 241, 0.5);
  border-radius: 20px;
}

.no-focus:focus,
.no-focus:focus-visible {
  border: none !important;
  box-shadow: none;
}

/* Hide elements dynamically on mobile */
@media (max-width: 767px) {
  .hidden-on-mobile {
    display: none !important;
  }

  .home_tile {
    min-height: 172px;
  }

  .home_tile > div {
    padding: 0px !important;
    padding-top: 4px !important;
  }

  /* .back-button {
    display: block;
  } */
}

@media (min-width: 767px) and (max-width: 1024px) {
  .home_tile > div {
    padding: 0px !important;
  }
}

@media (min-width: 768px) {
  .mobileOnly {
    display: none !important;
  }
}

@media (min-width: 1024px) {
  /* .body-main {
    padding-left: 5%;
    padding-right: 5%;
  } */
  main {
    margin-left: 5%;
    margin-right: 5%;
  }

  /* header{
    padding-left: 6%;
      padding-right: 6%;
  } */
}

header {
  padding-left: 2%;
  padding-right: 2%;
}

.body-main {
  background-color: white;
  overflow-y: auto;
}

.home_tile {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.home_tile:hover {
  transform: translateY(-5px) scale(1.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

/* Icon Animation on Hover */
.home_tile:hover .home_icon {
  transform: scale(1.2) rotate(5deg);
  transition: transform 0.3s ease-in-out;
}

.pageTitle {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 25px;
  margin-top: 5px;
}

header {
  padding-left: 5rem;
  padding-right: 5rem;
}

@media (max-width: 767px) {
  .main-content {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  header {
    padding-left: 3% !important;
    padding-right: 3% !important;
  }

  .mobileOnly {
    display: block !important;
  }
}

/*tablet*/
@media (min-width: 767px) and (max-width: 1100px) {
  .main-content {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  .page-with-sidebar {
    grid-template-columns: 200px auto;
  }
}

.custom-breadcrumb {
  margin-left: 0px;
  margin-bottom: 15px;
  margin-top: 10px;
}

@media print {
  .p-button,
  .breadcrumb,
  .main-header {
    display: none !important;
  }

  body {
    background: white !important;
  }

  .main-content {
    padding: 0 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,qCAAqC;EACrC,gCAAgC;EAChC,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,mCAAmC;;EAEnC,8BAA8B;EAC9B,iCAAiC;EACjC,iCAAiC;EACjC,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,6BAA6B;EAC7B;;eAEa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B;;;;GAIC;AACH;;AAEA;EACE,4BAA4B;EAC5B;;;;GAIC;AACH;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wDAAwD;EACxD,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,+DAA+D;EAC/D,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;;EAElB;IACE,iBAAiB;IACjB,gBAAgB;IAChB,2CAA2C;EAC7C;;EAEA;IACE,iBAAiB;;IAEjB;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;;EAEnB;IACE,wCAAwC;IACxC,wBAAwB;IACxB,2BAA2B;IAC3B,8BAA8B;IAC9B,UAAU;IACV,SAAS;;IAET;MACE,aAAa;IACf;EACF;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,oEAAqE;IACrE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,2CAA2C;EAC7C;;EAEA;IACE,gDAA6C;IAC7C,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,wCAAwC;;EAExC;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,oEAAoE;EACpE,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;;EAEZ;;KAEG;;EAEH;IACE,oEAAwE;EAC1E;AACF;;AAEA;EACE,oEAAoE;EACpE,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;;EAEZ;;KAEG;;EAEH;IACE,oEAAwE;EAC1E;AACF;;AAEA;EACE,oEAAiE;EACjE,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;;EAEZ;;KAEG;;EAEH;IACE,oEAAqE;EACvE;AACF;;AAEA;EACE,oEAA0E;EAC1E,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;;EAEZ;;KAEG;;EAEH;IACE,oEAAwE;EAC1E;AACF;;AAEA;EACE,oEAA0E;EAC1E,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;;EAEZ;;KAEG;;EAEH;IACE,oEAAwE;EAC1E;AACF;;AAEA;EACE,qEAAuE;EACvE,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;;EAEZ;;KAEG;;EAEH;IACE,oEAAqE;EACvE;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,WAAW;AACX;EACE;IACE,2BAA2B;IAC3B,mCAAmC;EACrC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;;;;;KAMG;;EAEH;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;KAEG;;EAEH;;KAEG;;EAEH;;KAEG;AACL;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;;KAEG;AACL;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;KAGG;EACH;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;KAGG;AACL;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA,4BAA4B;AAC5B;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,SAAS;AACT;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;1,400;1,700&display=swap\");\n\n:root {\n  --branded-purple: rgb(135, 60, 170);\n  --branded-purple-border: #beaad6;\n  --branded-light-purple: #e7e0f1;\n  --branded-extra-light-purple: #f9f3ff;\n  --branded-action-purple: #8c28e4;\n  --branded-blue: #00508e;\n  --branded-darker-gray: #333333;\n  --branded-dark-gray: #22272a;\n  --branded-light-gray: #ccced0;\n  --branded-font-color: #383838;\n  --branded-text-color: #495057;\n  --branded-gray: #f2f2f2;\n  --branded-error-red: #b30000;\n  --branded-yellow: #f2c94c;\n  --branded-validation-green: #00b298;\n\n  --branded-traffic-red: #b81d13;\n  --branded-traffic-red-bg: #f9cac7;\n  --branded-traffic-yellow: #8f6e00;\n  --branded-traffic-yellow-bg: #ffe693;\n  --branded-traffic-green: #008450;\n  --branded-traffic-green-bg: #b3ffe1;\n}\n\nhtml,\nbody {\n  padding: 0;\n  margin: 0;\n  font-family: \"Lato\", sans-serif;\n  background-color: var(--branded-gray);\n}\n\nheader > .wrapper > a {\n  min-width: 130px;\n}\n\n.custom-theme {\n  display: grid;\n  height: 100vh;\n  grid-template-columns: auto;\n  grid-template-rows: 80px auto;\n  grid-template-areas:\n    \"header\"\n    \"body-main\";\n  transition: grid 300ms ease;\n}\n\n.page-with-sidebar {\n  display: grid;\n  grid-template-columns: 250px auto;\n  grid-template-areas: \"sidebar main-content\";\n}\n\n.main-content {\n  border-radius: 0;\n  box-shadow: none !important;\n  margin-right: 0 !important;\n  height: calc(100vh - 100px);\n  padding-top: 0px !important;\n  padding-bottom: 50px !important;\n  padding-left: 5rem;\n  padding-right: 5rem;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n.container {\n  width: 1200px;\n  margin: 0 auto;\n}\n\n.blue-gradient {\n  background: rgb(20, 93, 154);\n  background: linear-gradient(\n    90deg,\n    rgba(20, 93, 154, 1) 0%,\n    rgba(0, 125, 211, 1) 100%\n  );\n}\n\n.green-gradient {\n  background: rgb(0, 178, 152);\n  background: linear-gradient(\n    90deg,\n    rgba(0, 178, 152, 1) 0%,\n    rgba(38, 66, 101, 1) 100%\n  );\n}\n\n.btn {\n  display: inline-flex;\n  cursor: pointer;\n  color: white;\n  font-size: 1rem;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  background-color: var(--branded-purple);\n}\n\n.btn-sm {\n  display: inline-flex;\n  cursor: pointer;\n  color: white;\n  font-size: 0.875rem;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  background-color: var(--branded-purple);\n}\n\nbutton:disabled,\nbutton[disabled] {\n  background-color: #cccccc;\n  color: #666666;\n  cursor: not-allowed;\n}\n\nbutton:disabled:hover,\nbutton[disabled]:hover {\n  color: white !important;\n}\n\n.custom-tooltip .p-tooltip-text {\n  font-size: 13px;\n  border: 1px solid var(--branded-light-purple) !important;\n  background-color: white !important;\n  color: #383838 !important;\n}\n\n.custom-tooltip .p-tooltip-arrow {\n  background-color: transparent !important;\n  border: none !important;\n}\n\nbody > iframe {\n  display: none;\n}\n\n.profile-menu img:hover {\n  border: none !important;\n}\n\n.custom_dialog {\n  padding: 25px !important;\n  background-color: white !important;\n}\n\n.custom_dialog .p-dialog-header {\n  border-bottom: 3px solid var(--branded-light-purple) !important;\n  padding: 0px 0px 15px 0px !important;\n}\n\n.custom_dialog .p-dialog-header-icon {\n  color: var(--branded-purple) !important;\n  background-color: rgba(222, 190, 237, 0.5) !important;\n}\n\n.custom_dialog .p-dialog-content {\n  padding: 15px 0px 0px 0px !important;\n}\n\n.custom_dialog .p-dialog-footer {\n  border-top: 0 !important;\n  padding: 15px 0px 0px 0px !important;\n}\n\n.header-menu {\n  border: solid 1px gray;\n  border-radius: 8px;\n\n  .p-menu .p-menuitem .p-menuitem-text {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: var(--branded-font-color) !important;\n  }\n\n  .p-menuitem-link {\n    font-size: 0.9rem;\n\n    .p-menuitem-text {\n      font-weight: 600;\n    }\n  }\n\n  .p-menu .p-menuitem .p-menuitem-icon {\n    font-size: 1rem;\n    font-weight: 500;\n  }\n\n  .p-panelmenu .p-panelmenu-header-link {\n    background-color: transparent;\n    color: #eff3f8;\n  }\n\n  .p-panelmenu .p-panelmenu-header-link:hover {\n    background-color: #22272a38;\n  }\n\n  .p-panelmenu .p-menuitem-link {\n    color: #ddd;\n  }\n\n  .p-panelmenu .p-menuitem-link:hover {\n    color: #fff;\n  }\n}\n\n.field-radiobutton label {\n  color: var(--branded-font-color);\n}\n\n.custom-breadcrumb {\n  background-color: transparent !important;\n  padding-top: 1.5rem;\n\n  ul {\n    background-color: transparent !important;\n    display: flex !important;\n    list-style: none !important;\n    flex-direction: row !important;\n    padding: 0;\n    margin: 0;\n\n    li:first-child {\n      display: none;\n    }\n  }\n\n  .p-breadcrumb-chevron::before {\n    display: inline-block;\n    color: transparent;\n    background: url(\"../assets/icons/chevron-right.svg\") no-repeat center;\n    width: 20px;\n    height: 20px;\n  }\n\n  .p-menuitem-text {\n    font-size: 1rem;\n    color: var(--branded-font-color) !important;\n  }\n\n  .pi .pi-home::before {\n    content: url(\"../assets/icons/home_icon.svg\");\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.sidebar-menu {\n  margin-top: 15vh;\n  width: 100% !important;\n  border: none !important;\n  background-color: transparent !important;\n\n  .p-menuitem-text,\n  .p-menuitem-icon {\n    color: #eff3f8 !important;\n  }\n\n  .p-menuitem-text {\n    font-size: 1.1rem !important;\n  }\n\n  .p-menuitem-link {\n    height: 56px;\n  }\n\n  .p-menuitem-link:not(.p-disabled):hover {\n    background: transparent !important;\n  }\n\n  .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover {\n    font-weight: 500 !important;\n    color: #eff3f8 !important;\n    background: #383c3f !important;\n  }\n\n  .p-focus .p-menuitem-link {\n    background-color: #383c3f !important;\n  }\n}\n\n.account-icon {\n  background: url(\"../assets/icons/account_icon.svg\") no-repeat center;\n  background-size: contain;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n\n  /* &:hover {\n    background: url('../assets/icons/account_icon_sel.svg') no-repeat center;\n  } */\n\n  &.selected {\n    background: url(\"../assets/icons/account_icon_sel.svg\") no-repeat center;\n  }\n}\n\n.profile-icon {\n  background: url(\"../assets/icons/profile_icon.svg\") no-repeat center;\n  background-size: contain;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n\n  /* &:hover {\n    background: url('../assets/icons/profile_icon_sel.svg') no-repeat center;\n  } */\n\n  &.selected {\n    background: url(\"../assets/icons/profile_icon_sel.svg\") no-repeat center;\n  }\n}\n\n.bell-icon {\n  background: url(\"../assets/icons/bell_icon.svg\") no-repeat center;\n  background-size: contain;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n\n  /* &:hover {\n    background: url('../assets/icons/bell_icon_sel.svg') no-repeat center;\n  } */\n\n  &.selected {\n    background: url(\"../assets/icons/bell_icon_sel.svg\") no-repeat center;\n  }\n}\n\n.account-icon-mobile {\n  background: url(\"../assets/icons/account_icon_black.svg\") no-repeat center;\n  background-size: contain;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n\n  /* &:hover {\n    background: url('../assets/icons/account_icon_sel.svg') no-repeat center;\n  } */\n\n  &.selected {\n    background: url(\"../assets/icons/account_icon_sel.svg\") no-repeat center;\n  }\n}\n\n.profile-icon-mobile {\n  background: url(\"../assets/icons/profile_icon_black.svg\") no-repeat center;\n  background-size: contain;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n\n  /* &:hover {\n    background: url('../assets/icons/profile_icon_sel.svg') no-repeat center;\n  } */\n\n  &.selected {\n    background: url(\"../assets/icons/profile_icon_sel.svg\") no-repeat center;\n  }\n}\n\n.bell-icon-mobile {\n  background: url(\"../assets/icons/bell_icon_black.svg\") no-repeat center;\n  background-size: contain;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n\n  /* &:hover {\n    background: url('../assets/icons/bell_icon_sel.svg') no-repeat center;\n  } */\n\n  &.selected {\n    background: url(\"../assets/icons/bell_icon_sel.svg\") no-repeat center;\n  }\n}\n\nlabel {\n  color: #495057 !important;\n}\n\n.line {\n  background-color: #e7e0f1;\n  height: 3px;\n  margin-top: 0px;\n  margin-bottom: 0px;\n  border: none;\n}\n\n.pageHeader {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  margin-bottom: 0px;\n  padding-bottom: 0px;\n}\n\n.pageHeaderCustom {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-right: 20px;\n  padding-top: 0px;\n  margin-top: -3px;\n}\n\n.p-calendar {\n  .p-button-icon-only {\n    height: 40px;\n  }\n\n  .p-inputtext {\n    border: none !important;\n  }\n}\n\n.p-multiselect .p-multiselect-label .p-placeholder {\n  font-size: 0.89rem !important;\n  color: #999999;\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .page-with-sidebar {\n    grid-template-columns: auto;\n    grid-template-areas: \"main-content\";\n  }\n\n  .sidebar {\n    display: none;\n  }\n}\n\n@media (max-width: 460px) {\n  /* header > .wrapper {\n    align-items: start;\n    gap: 1rem;\n    padding-left: 0;\n    padding-right: 0;\n    flex-wrap: wrap;\n  } */\n\n  .custom-breadcrumb {\n    padding-top: 1rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .main-content {\n    height: calc(100vh - 100px);\n  }\n\n  /* .custom-theme {\n    grid-template-rows: 130px auto !important;\n  } */\n\n  /* header .nav-top {\n    justify-content: start;\n  } */\n\n  /* .body-main {\n    height: calc(100vh - 80px) !important;\n  } */\n}\n\n.rlink-card {\n  background-color: rgba(231, 224, 241, 0.5);\n  border-radius: 20px;\n}\n\n.no-focus:focus,\n.no-focus:focus-visible {\n  border: none !important;\n  box-shadow: none;\n}\n\n/* Hide elements dynamically on mobile */\n@media (max-width: 767px) {\n  .hidden-on-mobile {\n    display: none !important;\n  }\n\n  .home_tile {\n    min-height: 172px;\n  }\n\n  .home_tile > div {\n    padding: 0px !important;\n    padding-top: 4px !important;\n  }\n\n  /* .back-button {\n    display: block;\n  } */\n}\n\n@media (min-width: 767px) and (max-width: 1024px) {\n  .home_tile > div {\n    padding: 0px !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .mobileOnly {\n    display: none !important;\n  }\n}\n\n@media (min-width: 1024px) {\n  /* .body-main {\n    padding-left: 5%;\n    padding-right: 5%;\n  } */\n  main {\n    margin-left: 5%;\n    margin-right: 5%;\n  }\n\n  /* header{\n    padding-left: 6%;\n      padding-right: 6%;\n  } */\n}\n\nheader {\n  padding-left: 2%;\n  padding-right: 2%;\n}\n\n.body-main {\n  background-color: white;\n  overflow-y: auto;\n}\n\n.home_tile {\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.home_tile:hover {\n  transform: translateY(-5px) scale(1.05);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n/* Icon Animation on Hover */\n.home_tile:hover .home_icon {\n  transform: scale(1.2) rotate(5deg);\n  transition: transform 0.3s ease-in-out;\n}\n\n.pageTitle {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 25px;\n  margin-top: 5px;\n}\n\nheader {\n  padding-left: 5rem;\n  padding-right: 5rem;\n}\n\n@media (max-width: 767px) {\n  .main-content {\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  }\n\n  header {\n    padding-left: 3% !important;\n    padding-right: 3% !important;\n  }\n\n  .mobileOnly {\n    display: block !important;\n  }\n}\n\n/*tablet*/\n@media (min-width: 767px) and (max-width: 1100px) {\n  .main-content {\n    padding-left: 2rem !important;\n    padding-right: 2rem !important;\n  }\n\n  .page-with-sidebar {\n    grid-template-columns: 200px auto;\n  }\n}\n\n.custom-breadcrumb {\n  margin-left: 0px;\n  margin-bottom: 15px;\n  margin-top: 10px;\n}\n\n@media print {\n  .p-button,\n  .breadcrumb,\n  .main-header {\n    display: none !important;\n  }\n\n  body {\n    background: white !important;\n  }\n\n  .main-content {\n    padding: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
